"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 * Le das el assignationId y te devuelve el appointment,
 * Tenes que pasarle si es de consultorio o online porque se guardan en distintos lugares
 *
 * @param firestore
 * @param country
 * @param data
 * @param options
 * @param useQueryOptions
 */
function useSpecialistActiveAppointment(firestore, country, data, options, useQueryOptions) {
    const appointmentRef = (0, firestore_2.doc)(firestore, `assignations/${data.type}/${country}/${data.assignationId}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "Specialist Active Appointment",
        path: `assignations/${data.type}/${country}/${data.assignationId}`
    }, [data.assignationId, data.type]), appointmentRef, options, useQueryOptions);
}
exports.default = useSpecialistActiveAppointment;
